export default __webpack_public_path__ + "media/images/logos/chas-logo-47dff1fbeb6f73de3b2339b903a6487d.png";